function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotakMahindraBanklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.45 90.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kotak Mahindra Bank logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M374.78,512c0-25.05,23.62-45.36,52.74-45.36s52.74,20.31,52.74,45.36-23.61,45.36-52.74,45.36S374.78,537.05,374.78,512",
    transform: "translate(-374.78 -466.64)",
    style: {
      fill: "#003974"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.34 14.57 58.59 10.52 58.65 76.76 46.29 80.9 46.34 14.57",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.39,522.52c-5.32,6.42-10.47,13-20.11,13-13.62,0-20.07-13.17-20.07-24.17,0-10.58,5-23.1,18.31-23.1,5.75,0,11.3,3.52,14.59,7.24v9c-2.76-1.85-8.94-3.68-13-3.75-8.41-.14-15.83,3.51-15.7,11.81.09,5.72,5.75,9.6,11.39,9.6,8.63,0,13.86-7.88,18.23-13.87,1.22-1.56,4.66-6.16,5.19-6.9,4.85-6.78,10.47-13,20.11-13,11.36,0,17.73,9.15,19.54,18.58h-5.12a12.18,12.18,0,0,0-9.93-4.93c-8.92,0-14.26,8.21-18.72,14.25,0,0-3.47,4.73-4.73,6.24m38.79-5.95c-1.15,9.47-6.46,19-18.07,19.07-6.78,0-12.07-4.63-15.73-10.31v-6.57c4.59,2.28,8.87,4.72,14.07,4.8,6.41.1,12.2-2.37,14.6-7Z",
    transform: "translate(-374.78 -466.64)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,525.76c-5,0-7-4.14-7-8.76s2-8.83,7-8.83,7,4.14,7,8.83-2,8.76-7,8.76m0,7.56c10.33,0,18.19-6,18.19-16.33s-7.86-16.39-18.19-16.39-18.19,6-18.19,16.39,7.86,16.33,18.19,16.33",
    transform: "translate(-374.78 -466.64)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.2,508.9h6.18v12.73c0,7.44,2.34,11.7,12,11.7a52.23,52.23,0,0,0,6.78-.6l-.36-7a20.63,20.63,0,0,1-3.3.42c-3.43,0-4.33-1.92-4.33-5.7V508.9h7.56v-7.56h-7.56V490.52l-10.62,3.79v7H554.2Z",
    transform: "translate(-374.78 -466.64)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.79 65.97 252.6 65.97 252.6 50.48 252.72 50.48 261.36 65.97 274.45 65.97 262.68 49.04 273.55 34.69 261.72 34.69 252.72 47.84 252.6 47.84 252.6 23.92 241.79 27.66 241.79 65.97",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.27 65.97 126.08 65.97 126.08 50.48 126.2 50.48 134.84 65.97 147.93 65.97 136.16 49.04 147.03 34.69 135.2 34.69 126.2 47.84 126.08 47.84 126.08 23.92 115.27 27.48 115.27 65.97",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.68,522.73c0-3,2.91-4.19,6.62-4.19,1.64,0,3.22.12,4.62.18,0,3.71-2.61,7.47-6.74,7.47-2.55,0-4.49-1.28-4.49-3.46m22.05,10a38.68,38.68,0,0,1-.61-7.47V513.5c0-9.66-7-13.12-15.07-13.12a32.69,32.69,0,0,0-12.64,2.25l.18,7.41a20.56,20.56,0,0,1,10.09-2.37c3.95,0,7.17,1.15,7.23,5.47a32.08,32.08,0,0,0-5.1-.43c-5.83,0-16.34,1.16-16.34,10.82,0,6.87,5.59,10,11.85,10,4.5,0,7.53-1.76,10-5.71h.12c0,1.64.19,3.28.25,5Z",
    transform: "translate(-374.78 -466.64)",
    style: {
      fill: "#ec1c24"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotakMahindraBanklogo);
export default __webpack_public_path__ + "static/media/Kotak Mahindra Bank logo.0af061436e37ec8b2d0f1cd489d98ee0.svg";
export { ForwardRef as ReactComponent };